<script>
  import { captureCreativeSession, retrySessionSave, sessionPersistence } from '../state/session-persistence.svelte.js';
  import { hasCreativeWork } from '../utils/session-snapshot.js';
  import { reloadSavedPhase } from '../utils/reload-saved-phase.js';

  let reloading = $state(false);
  let reloadError = $state(null);

  async function saveAndReload() {
    reloading = true;
    reloadError = null;
    try {
      await reloadSavedPhase({
        capture: captureCreativeSession,
        hasWork: hasCreativeWork,
        save: retrySessionSave,
        reload: () => location.reload()
      });
    } catch (error) {
      reloadError = error.message;
    } finally {
      reloading = false;
    }
  }
</script>

<button class="btn-secondary" onclick={saveAndReload} disabled={reloading || !sessionPersistence.ready}>
  {reloading ? 'Saving…' : 'Save & reload'}
</button>
{#if reloadError}<p role="alert">{reloadError}</p>{/if}

<style>
  button { min-height: 44px; }
  button:focus-visible { outline: 2px solid var(--color-primary); outline-offset: 3px; }
  p { flex-basis: 100%; }
</style>
